export { default as Gauge } from './gauge/index.vue';
export { default as MiniArea } from './mini-area/index.vue';
export { default as Pie } from './pie/index.vue';
export { default as TagCloud } from './tag-cloud/index.vue';
export { default as WaterWave } from './water-wave/index.vue';
